import { useGetEvent } from "@/api/event/useGetEvent";
// import { GetMyUpcomingReservationsDto } from "@/api/user/useGetMyUpcomingReservations";
import { useGetMySummary } from "@/api/user/useGetMySummary";
import { useGetMyUpcomingReservations } from "@/api/user/useGetMyUpcomingReservations";
import { Error } from "@/components/Error";
import { BackButton } from "@/components/shared/BackButton";
import { StyledActionButton } from "@/components/shared/StyledActionButton";
import { Center, Loader, Stack, Text, Title } from "@mantine/core";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { EventDetail } from "./EventDetail";
import { ReservationList } from "./ReservationList";

export function UpcomingReservations() {
  const { reservationId } = useParams<{ reservationId: string }>();
  const selectedReservationId = reservationId ? Number(reservationId) : null;
  const navigate = useNavigate();

  const {
    data: upcomingReservations,
    isPending: isUpcomingReservationsPending,
    isError: isUpcomingReservationsError,
  } = useGetMyUpcomingReservations();

  // Use React Query's select to derive the selected reservation from the query data
  const selectedReservation =
    upcomingReservations?.find((r) => r.id === selectedReservationId) ?? null;

  const { data: event, isLoading } = useGetEvent(selectedReservation?.eventId ?? null);
  const { data: userSummary } = useGetMySummary();

  const noReservationsContent = (
    <Stack justify="center" align="center" flex={1}>
      <Stack align="center">
        <Title ta="center">{userSummary?.name}님을 기다리고 있어요! 🎉 </Title>
        <Text ta="center">아직은 예약이 없어요</Text>
        <StyledActionButton size="md" component={NavLink} to="/event-reservation">
          다음 이벤트 예약하기
        </StyledActionButton>
      </Stack>
    </Stack>
  );

  if (isUpcomingReservationsPending) {
    return (
      <Center h="100%">
        <Loader />
      </Center>
    );
  }

  if (isUpcomingReservationsError) {
    return <Error errorMessage="오류가 발생했습니다. 잠시후 다시 시도해주세요." />;
  }

  return (
    <>
      {selectedReservation && (
        <BackButton
          onClick={() => navigate("/home/reservation/upcoming")}
          style={{ top: 25, left: 10 }}
        />
      )}
      {upcomingReservations?.length === 0 && noReservationsContent}

      <Stack py="xl" pos="relative">
        {selectedReservation ? (
          isLoading || !event ? (
            <Center h="100%">
              <Loader />
            </Center>
          ) : (
            <EventDetail
              reservation={selectedReservation}
              onBack={() => navigate("/home/reservation/upcoming")}
              event={event}
            />
          )
        ) : (
          <ReservationList
            reservations={upcomingReservations}
            onReservationSelect={(reservation) =>
              navigate(`/home/reservation/upcoming/${reservation.id}`)
            }
          />
        )}
      </Stack>
    </>
  );
}
